import { saveAs } from 'file-saver';
import gmt from './gmt';

export default {
  mixins: [gmt],
  methods: {
    async downloadPackage(id) {
      const response = await this.$store.dispatch('primary/getDeploymentDownloadURL', { id });
      saveAs(response.url);
    },
    async deleteDeployment(id) {
      const response = await this.$store.dispatch('primary/deleteDeployment', { id });
      return response;
    },
    deploymentLink(deployment) {
      return {
        name: 'deployments.index.details',
        params: { id: deployment.id },
      };
    },
    profileLink(deployment) {
      return {
        name: 'profiles.index.detail',
        params: { id: deployment.profile.id },
      };
    },
    keyValues(deployment) {
      return [
        {
          label: 'Name',
          field: 'name',
          value: deployment.name,
        },
        {
          label: 'Status',
          field: 'status',
          value: deployment.status,
        },
        {
          label: 'Created',
          field: 'created',
          value: this.$options.filters.formatEpochDate(deployment.created, this.gmt),
        },
        {
          label: 'Package',
          field: 'package_id',
          value: `${deployment.package.major}.${deployment.package.minor}.${deployment.package.build}`,
        },
        {
          label: 'Profile',
          field: 'profile_id',
          value: deployment.profile.name,
          link: this.profileLink(deployment),
        },
      ];
    },
  },
};
